import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import WebFont from 'webfontloader';

import App from './App';
import './assets/scss/main.scss';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './components/UI/DynamicIcon/DynamicIcon';
import { ConfigProvider } from './shared/config';

// Todo: Better place for WebFont Loader?
if (process.env.REACT_APP_FONT_URL) {
    WebFont.load({
        custom: { families: [process.env.REACT_APP_FONT_FAMILIES], urls: [process.env.REACT_APP_FONT_URL] },
    });
}

if ('OTPCredential' in window) {
    const abortController = new AbortController();
    navigator.credentials
        .get({ otp: { transport: ['sms'] }, signal: abortController.signal })
        .then((credential) => {
            if (credential?.code) {
                localStorage.setItem('webOtpCode', JSON.stringify(credential.code));
            }
        })
        .catch((err) => {
            console.log('OTP credential resolving failed with:', err);
        });
}

const app = (
    <React.StrictMode>
        <ConfigProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </ConfigProvider>
    </React.StrictMode>
);

createRoot(document.getElementById('root')).render(app);
serviceWorkerRegistration.unregister();
